import React from 'react';
import { Button, ButtonGroup } from '@blueprintjs/core';
import SSDContent from './ssdcontent';

export default class SolutionVisualizer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { final: true, step: 1 };
    }

    static getDerivedStateFromProps(props, state) {
        if (props && props.refPages) {
            if (state.step > props.refPages.length)
                return { step: props.refPages.length };
        }
        return null;
    }

    render() {
        return <>
            <div className="ssd-solution-container">
                <div className="ssd-solution-controls">
                    <ButtonGroup>
                        <Button 
                            text="Végeredmény"
                            active={this.state.final}
                            onClick={() => this.setState({final: true})}
                        />
                        <Button 
                            text="Lépésenként"
                            active={!this.state.final}
                            onClick={() => this.setState({final: false})}
                        />
                    </ButtonGroup>
                    <div className="ssd-solution-steps" style={{ visibility: this.state.final ? "hidden" : "visible"}}>
                        <ButtonGroup>
                            <Button 
                                icon="caret-left"
                                onClick={() => this.setState(state => ({ step: Math.max(1, state.step-1)}))}
                            />
                            <Button 
                                icon="caret-right"
                                onClick={() => this.setState(state => ({step: Math.min(this.props.refPages.length, state.step+1)}))}
                            />
                        </ButtonGroup>                    
                        <div>{this.state.step}. lépés: {this.props.refPages[this.state.step-1]} írása</div>
                    </div>                    
                </div>

                <div className="ssd-solution-main">
                    <div className="ssd-solution-state">
                        <p>{this.state.final ? "Az SSD végállapota:" : "Az SSD állapota az írási művelet után:"}</p>
                    <SSDContent
                        content={this.props.solutions[this.state.final ? this.props.refPages.length : this.state.step]} 
                        prevContent={this.props.solutions[this.state.step-1]}
                        markChanges={!this.state.final}                         
                    />
                    </div>
                </div>            
            </div>
        </>;
    }

}
